<template>
  <div>
    <CCard class="mob-pd-0px">
      <CCardHeader class="grey-header d-flex mob-flex-column ai-center">
        <CRow class="flex-flow-column">
          <CCol>
            <strong>{{ $t("agentGroup.title") }}</strong>
          </CCol>

          <p class="desc">{{ $t("agentGroup.desc") }}</p>
        </CRow>
        <CButton
          @click="navigateToAddAgtGrp(null)"
          size="sm"
          color="success"
          class="ml-auto btn-lit-blue mob-w100"
        >{{ $t("agentGroup.addAgtGrp") }}</CButton>
      </CCardHeader>

      <CCardBody v-if="allB2bGrpLs" class="user-manage-table pt-0px">
        <div class="m-auto max-width-1000px">
          <div class="card assign pricing-card sticky-title-bar z-index-9999">
            <div class="d-flex">
<!--              <label class="d-flex align-items-center mb-0">Group Name</label>-->
              <multiselect
                class="multiselect-assignprice"
                :searchable="true"
                :close-on-select="true"
                :track-by="'b2bGroupid'"
                :label="'groupname'"
                v-model="selectedAgt"
                :allow-empty="false"
                :show-labels="false"
                @input="onChange"
                :options="allB2bGrpLs.groupList"
                :placeholder="$t('agentGroup.selectGrp')"
              >
                <template #noResult>
                <strong >
                  {{$t('agentGroup.listEmpty')}}
                </strong>
              </template>
                <!-- <template slot="option" slot-scope="props">
                  <div class="d-flex">
                    <span>{{ props.option['contractcode'] }}</span>
                  </div>
                </template> -->
              </multiselect>
            </div>

          </div>

           <div class="page-controllers d-flex flex-flow-row justify-content-between card assign pricing-card ">

                        <div class="page-controller-wrap d-flex ">
                            <div class="d-flex align-item-center per-item">
                                <span class="align-item-center d-flex w-185px">{{$t('manageAgent.itemsPerPage')}}</span>
                                <select class="form-control" v-model="pageWatchList.itemsPerPage">
                                    <option v-for="itemsPerPage in pageWatchList.lsItemsPerPage" :key="itemsPerPage"
                                            :value="itemsPerPage">{{itemsPerPage}}
                                    </option>

                                </select>
                            </div>

                        </div>
             <div class="d-flex align-item-center page-n">
               <div class="mr-15px">
                 <cPaginationLenOption :paginationWatchLs="pageWatchList"/>
               </div>
               <CPagination
                       :activePage.sync="pageWatchList.currentPageNum"
                       :pages="getTotalPages()"
                       align="center"
               />
             </div>


                    </div>


          <div v-for="(agtLs,agtIndex) in selectedAgtLs" :key="'agtGrp'+agtIndex">
            <CCard v-if="agtLs.groupname!='All' && getListCountForView(agtIndex!=0?agtIndex-1:agtIndex)"
              class="card assign pricing-card b-r-color" 
             >
             <div @click.stop="allB2bGrpLs.permission.canEdit?navigateToAddAgtGrp(agtLs):null">
              <div class="card-head d-flex ai-center">
                <div class="d-flex align-items-center justify-content-between w-100" v-if="agtLs.groupname">
                  <div class="mr-10px w-100">
                    <h3 v-if="agtLs.groupname" class="text-transform-uppercase">{{agtLs.groupname}}</h3>
                    <span v-if="agtLs.description" class="text-ellipsis d-block">{{agtLs.description}}</span>
                  </div>
                </div>
                <div class="align-right d-flex">
                
                </div>
              </div>
              <div class="card-head d-flex ai-center justify-content-between d-flex pt-0px bb-none">
                <div class="align-left a-name">
                  <table class="contract agent-grouping">
                    <tbody v-for="(agency,aIndex) in agtLs.b2bCompanyGroupMembers" :key="'agency'+aIndex">
                      <tr v-if="agency.b2b">
<!--                         <td>{{$t("contract.airlineCode")}}</td>-->
                         <td><img src="@imgPath/img/svg/icons/green-tick.svg" alt="" width="12px"></td>
                        <td>{{agency.b2b.agencyname}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="button-wrap-r mt-auto">
                  <div class="row">
                    
                    <CCol>
                      <div
                              @click.stop="toDeleteContract(agtLs.b2bGroupid)"
                              col="2.5"
                              v-if="allB2bGrpLs.permission.canDelete"
                              size="sm"
                              color="danger"
                              v-c-tooltip.hover="{ content: $t('agentGroup.deleteTooltip') , active:false }"
                              class=" icon-25px c-pointer"
                      >
                        <CIcon style="color: #cd0606;font-size:22px;" name="cil-trash" size="lg"></CIcon>
                      </div>
                    </CCol>
                    <CCol>
                      <div
                              @click.stop="navigateToAddAgtGrp(agtLs)"
                              col="2.5"
                              v-if="allB2bGrpLs.permission.canEdit"
                              class="edit-icon icon-25px c-pointer"
                              color="info removewrap"
                              v-c-tooltip.hover="{ content: $t('agentGroup.editTooltip') , active:false }"
                      >
                        <svg
                                xmlns="http://www.w3.org/2000/svg"
                                height="512pt"
                                viewBox="0 0 512 512"
                                width="512pt"
                                style="fill:#3c4b64;"
                        >
                          <path
                                  d="m368 511.957031h-309.332031c-32.363281 0-58.667969-26.304687-58.667969-58.667969v-309.332031c0-32.363281 26.304688-58.667969 58.667969-58.667969h181.332031c8.832031 0 16 7.167969 16 16 0 8.832032-7.167969 16-16 16h-181.332031c-14.699219 0-26.667969 11.96875-26.667969 26.667969v309.332031c0 14.699219 11.96875 26.667969 26.667969 26.667969h309.332031c14.699219 0 26.667969-11.96875 26.667969-26.667969v-181.332031c0-8.832031 7.167969-16 16-16s16 7.148438 16 16v181.332031c0 32.363282-26.304688 58.667969-58.667969 58.667969zm0 0"
                          />
                          <path
                                  d="m187.136719 340.820312c-4.203125 0-8.300781-1.664062-11.308594-4.691406-3.796875-3.777344-5.417969-9.21875-4.371094-14.445312l15.082031-75.433594c.617188-3.113281 2.152344-5.953125 4.371094-8.171875l220.953125-220.925781c22.867188-22.871094 60.074219-22.871094 82.964844 0 11.070313 11.070312 17.171875 25.792968 17.171875 41.472656s-6.101562 30.398438-17.195312 41.472656l-220.925782 220.949219c-2.21875 2.238281-5.078125 3.753906-8.171875 4.371094l-75.414062 15.082031c-1.046875.214844-2.113281.320312-3.15625.320312zm75.433593-31.082031h.214844zm-45.609374-52.457031-9.410157 47.144531 47.125-9.429687 217.515625-217.511719c5.035156-5.058594 7.808594-11.734375 7.808594-18.859375s-2.773438-13.804688-7.808594-18.859375c-10.367187-10.390625-27.285156-10.390625-37.714844 0zm0 0"
                          />
                          <path
                                  d="m453.332031 134.976562c-4.09375 0-8.191406-1.558593-11.304687-4.695312l-60.332032-60.351562c-6.25-6.25-6.25-16.382813 0-22.632813s16.382813-6.25 22.636719 0l60.328125 60.351563c6.25 6.25 6.25 16.382812 0 22.632812-3.136718 3.117188-7.230468 4.695312-11.328125 4.695312zm0 0"
                          />
                        </svg>
                      </div>
                    </CCol>
                    <CCol @click.stop="agtLs.isShowAgentDpModal=!agtLs.isShowAgentDpModal">
                     <div
                    col="1.5"
                    size="sm"
                    color="info removewrap"
                     v-c-tooltip.hover="{ content: $t('agentGroup.viewTooltip') , active:false }"
                    class=" icon-25px c-pointer"
                  >
                         <img src="@imgPath/img/svg/icons/chart-icon.svg" alt="" width="24px">
<!--                    <CIcon  name="cil-chat" size="lg"></CIcon>-->
                  </div>
                  </CCol>
                    

                  </div>
                </div>
              </div>
              </div>
               <cSysMiniAgentDB v-if="agtLs.isShowAgentDpModal" @closeDBModal="agtLs.isShowAgentDpModal=false" 
           :isShowAgentDpModal="agtLs.isShowAgentDpModal" :selAgentgroup="agtLs"> </cSysMiniAgentDB>
            </CCard>
          </div>
          
   
          <CRow>
            <CAlert v-if="alertValue" show color="danger">
              <div v-if="alertValue&&alertValue.hasOwnProperty('valueList')">
                <p v-for="(value,index) in alertValue.valueList" :key="index">{{value}}</p>
              </div>
              <div v-if="alertValue&&alertValue.hasOwnProperty('codeList')">
                <span>{{'ErrorCode: '}}</span>
                <span v-for="(code,index) in alertValue.codeList" :key="index">{{code +' '}}</span>
              </div>
              <div v-if="alertValue&&alertValue.constructor==String">
                <p>{{alertValue}}</p>
              </div>
            </CAlert>
          </CRow>
          <CRow>
            <CCol id="user-manage-table" class="usersTable border-grey manage-user-table"></CCol>
          </CRow>
        </div>
      </CCardBody>
      <cAlertModal
        v-if="isShowAlertModal"
        :key="'CA'+alertCount"
        :buttonList="modalButton"
        :status="modalStatus"
        :isShowIcon="true"
        :show="isShowAlertModal"
        :desc="confirmTxt"
      ></cAlertModal>
    </CCard>
    <!-- <CModal :show.sync="toShowModal" size="xl" class="sub-dash-wrap" :closeOnBackdrop="true">
      <template #header-wrapper>
        <div></div>
      </template>

        

    </CModal> -->
  </div>
</template>

<script>
import router, { navigate } from "../../router/index";
import cSysMiniAgentDB from "../../components/dashboard/system/miniAgentDP/cSysMiniAgentDB";
import { mapGetters, mapActions } from "vuex";
import {
  PATHNAME,
  COMPONENT_NAME,
  DEFAULT_DROPDOWN_STATUS,
  ORDER,
  ALERT_MODAL_STATUS
} from "../../util/constants";
import Logger from "../../services/logger";
import SERVICE_URL, {
  FILE_NAME,
  LOG_TYPE,
  HTTP_CODES
} from "../../config/API_DATA";
import multiselect from "vue-multiselect";
import {
  VALIDATE_SUCCESS_RES,
  getErrorMessage
} from "../../util/apiValidate";
import {
  handleJWT,
  getErrorAlertValue,
  addClassToBody,
  removeClassBody,
  OrderByList,
  cloneData,
  cloneDeep
} from "../../util/util";
import BaseConfiguration from "../../config/base.js";
import apiGetB2bGroupList from "../../services/apiGetB2bGroupList";
import apiDeleteB2bGroup from "../../services/apiDeleteB2bGroup";
import cAlertModal from "../../components/form/cAlertModal";
import apiCRSGetFareRule from "../../services/apiCRSGetFareRule";
import cPaginationLenOption from "../../components/dataTable/cPaginationLenOption";

export default {
  name: COMPONENT_NAME.AGENTGROUP_ALL,
  components: {
    cSysMiniAgentDB,
    multiselect,
    cAlertModal,
    cPaginationLenOption
  },

  data: () => {
    return {
      allB2bGrpLs: null,
      alertValue: null,
     selectedAgt: null,
     selectedAgtLs: [],
      selContDet: null,
      alertCount:0,
      modalStatus: ALERT_MODAL_STATUS.INFO,
      modalButton: null,
      isShowAlertModal: false,
      toShowModal: false,
       pageWatchList: {
                    filteredlistCount: null,
                    itemsPerPage: 25,
                    currentPageNum: 1,
                    lsItemsPerPage: [5, 10, 15, 25]
                },
      isShowAgentDpModal:false
    };
  },

   watch: {
            selectedAgtLs: {
                immediate: false,
                deep: true,
                handler: function (newVal, oldVal) {


                    this.pageWatchList.filteredlistCount = this.selectedAgtLs.length-1;


                },
            }

        },

  methods: {
    ...mapActions("sAgentGroup", ["SET_SELECTED_AGENT_GROUP"]),
        ...mapActions("sAgentGroup", ["SET_ALL_CONTRACT_RES"]),

     getTotalPages() {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("getTotalPages");
                    if (this.pageWatchList.filteredlistCount != null) {
                        let totalPages = this.pageWatchList.filteredlistCount / this.pageWatchList.itemsPerPage;
                        retValue = Math.ceil(totalPages);


                        if (retValue <= 0) {
                            retValue = 1;
                        }
                    } else {
                        retValue = 1;
                    }


                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.CONTRACT_ALL,
                        "error in getTotalPages",
                        err.toString(),
                        "getTotalPages",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
     },

             getStartValueCount() {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("getStartValueCount");
                    if (this.pageWatchList.filteredlistCount == 0) {
                        retValue = 0;
                    } else {
                        if (
                            this.pageWatchList.itemsPerPage <
                            this.pageWatchList.filteredlistCount
                        ) {
                            retValue =
                                (this.pageWatchList.currentPageNum - 1) *
                                this.pageWatchList.itemsPerPage;
                            retValue = retValue + 1;
                        } else {
                            retValue = 1;
                        }
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.CONTRACT_ALL,
                        "error in getStartValueCount",
                        err.toString(),
                        "getStartValueCount",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },
            getListCountForView(pIndex) {
                try {
                    if (BaseConfiguration.isDebug) console.log("getListCountForView");
                    let count = 0;


                    count = pIndex + 1;


                    if (count >= this.getStartValueCount() && count <= this.getFilteredListPerPage()) {
                        return true;
                    } else {
                        return false;
                    }

                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.CONTRACT_ALL,
                        "error in getListCountForView",
                        err.toString(),
                        "getListCountForView",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },
            getFilteredListPerPage() {
                let retValue;

                try {
                    if (BaseConfiguration.isDebug) console.log("getFilteredListPerPage");
                    if (
                        this.pageWatchList.itemsPerPage <
                        this.pageWatchList.filteredlistCount
                    ) {
                        if (
                            this.pageWatchList.currentPageNum *
                            this.pageWatchList.itemsPerPage >
                            this.pageWatchList.filteredlistCount
                        ) {
                            retValue = this.pageWatchList.filteredlistCount;
                        } else {
                            retValue =
                                this.pageWatchList.currentPageNum *
                                this.pageWatchList.itemsPerPage;
                        }
                    } else {
                        retValue = this.pageWatchList.filteredlistCount;
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.CONTRACT_ALL,
                        "error in getFilteredListPerPage",
                        err.toString(),
                        "getFilteredListPerPage",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },



    onChange(pSelectedAgt) {
     // let retValue;
      let allAgtLs;
      try {
        if (BaseConfiguration.isDebug) console.log("onChange");
        this.selectedAgtLs = [];
        if(pSelectedAgt.groupname && pSelectedAgt.groupname == DEFAULT_DROPDOWN_STATUS.ALL){
          this.selectedAgtLs = this.allB2bGrpLs.groupList
        }
        else{
        allAgtLs = this.allB2bGrpLs;
        this.selectedAgtLs.push(this.allB2bGrpLs.groupList[0])
        for (let i = 0; i < allAgtLs.groupList.length; i++) {
          if (
            pSelectedAgt.b2bGroupid ==
              allAgtLs.groupList[i].b2bGroupid &&
            pSelectedAgt.b2bGroupid != null
          ) {
            //this.selContDet = allAgtLs.contractList[i];
            this.selectedAgtLs.push(cloneDeep(allAgtLs.groupList[i]))
            break;
          }
        }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CONTRACT,
          "error in onChange",
          err.toString(),
          "onChange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
     // return retValue;
    },

    toggleShowAlertModal() {
      this.isShowAlertModal = !this.isShowAlertModal;
      this.modalStatus = ALERT_MODAL_STATUS.INFO;
    },

    toDeleteContract(pB2bGroupid) {
      try {
        if (BaseConfiguration.isDebug) console.log("toDeleteContract");

        this.showAlertModal(
          ALERT_MODAL_STATUS.INFO,
          this.$t("agentGroup.deleteConfirm"),
          pB2bGroupid
        );
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.EXTENSION_SETUP,
          "error in toDeleteContract",
          err.toString(),
          "toDeleteContract",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      // return retValue;
    },

    showAlertModal(status, val, pParam) {
      this.isShowAlertModal = true;
      this.alertCount += 1;
      this.modalStatus = status;

      if (status == ALERT_MODAL_STATUS.INFO) {
        this.modalButton = [
          {
            name: this.$t("addContract.no"),
            func: this.toggleShowAlertModal
          },
          {
            name: this.$t("addContract.yes"),
            func: this.deleteB2bGroup,
            param: pParam ? pParam : null
          }
        ];
      } else if (status == ALERT_MODAL_STATUS.SUCCESS || status == ALERT_MODAL_STATUS.FAIL) {
        this.modalButton = [
          {
            name: this.$t("addContract.ok"),
            func: this.toGetB2bGroupList
          }
        ];
      }
      this.confirmTxt = val;
    },

    async GetB2bGroup() {
      if (BaseConfiguration.isDebug) console.log("GetB2bGroup");
      let returnValue;
      try {
        let getB2bGroupListReq = apiGetB2bGroupList.buildRequest(); //constant

        if (getB2bGroupListReq != null) {
          let getB2bGroupListRes = await apiGetB2bGroupList.getResponse(
            getB2bGroupListReq
          );
          if (VALIDATE_SUCCESS_RES(getB2bGroupListRes)) {
                        this.alertValue=null;

            // this.SET_ALL_CONTRACT_RES(cloneData(getB2bGroupListRes.data.data.groupList));
            returnValue = getB2bGroupListRes.data.data;
          } else {
            let error = getErrorMessage(getB2bGroupListRes);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue=getErrorAlertValue(error);
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CONTRACT,
          "error in  getgetB2bGroupList",
          err.toString(),
          "getgetB2bGroupList()",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return returnValue;
    },

    async deleteB2bGroup(pB2bGroupid) {
      if (BaseConfiguration.isDebug) console.log("deleteB2bGroup");
      let returnValue;
      try {
        if(this.toShowModal==true){
          this.toShowModal=false;
        }
        this.isShowAlertModal = false;
        let deleteB2bGroupReq;
        if (pB2bGroupid) {
          deleteB2bGroupReq = apiDeleteB2bGroup.buildRequest(pB2bGroupid); //constant
        }
        if (deleteB2bGroupReq != null) {
          let deleteB2bGroupRes = await apiDeleteB2bGroup.getResponse(
            deleteB2bGroupReq
          );
          if (VALIDATE_SUCCESS_RES(deleteB2bGroupRes)) {
                         this.alertValue=null;

            returnValue = deleteB2bGroupRes.data.data;
            this.showAlertModal(
              ALERT_MODAL_STATUS.SUCCESS,
              this.$t("agentGroup.deleteSuccess")
            );
          } else {
            let error = getErrorMessage(deleteB2bGroupRes);
            
            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue=getErrorAlertValue(error,true,true);
            }
            this.showAlertModal(
              ALERT_MODAL_STATUS.FAIL,
              this.alertValue
            );
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CONTRACT,
          "error in  deleteB2bGroup",
          err.toString(),
          "deleteB2bGroup()",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return returnValue;
    },

  

    navigateToAddAgtGrp(pSelectedAgt) {
      try {
        if (BaseConfiguration.isDebug) console.log("navigateToAddAgtGrp");
        if (pSelectedAgt) {
          this.SET_SELECTED_AGENT_GROUP(pSelectedAgt);
        } else {
          this.SET_SELECTED_AGENT_GROUP(null);
        }
        navigate(PATHNAME.AGENTGROUP_NEW);
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.CONTRACT_ALL,
          "error in navigateToAddAgtGrp",
          err.toString(),
          "navigateToAddAgtGrp",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    async toGetB2bGroupList() {
      try {
        if (BaseConfiguration.isDebug) console.log("toGetB2bGroupList");
        let agtGrpLs = await this.GetB2bGroup();
        this.isShowAlertModal = false;
        let allAgt;
        allAgt = {
          groupname: DEFAULT_DROPDOWN_STATUS.ALL,
          b2bGroupid: null
        };
        if(agtGrpLs) {
        agtGrpLs.groupList.unshift(allAgt);
        this.allB2bGrpLs = agtGrpLs;
        this.selectedAgt = this.allB2bGrpLs.groupList[0];
        let agentLS= this.allB2bGrpLs.groupList;
       
       for (let i = 0; i < agentLS.length; i++) {
         if(agentLS[i]){
           agentLS[i]["isShowAgentDpModal"] = false;
         }
         
       }
       this.selectedAgtLs = cloneDeep(agentLS)
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CONTRACT_ALL,
          "error in toGetB2bGroupList",
          err.toString(),
          "toGetB2bGroupList",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    }
  },

  async created() {
    try {
      this.toGetB2bGroupList();
    } catch (err) {
      let body = Logger.buildRequest(
        COMPONENT_NAME.CONTRACT_ALL,
        "error in  Created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  },
  computed: {},
  beforeCreate() {
    addClassToBody(COMPONENT_NAME.AGENTGROUP_ALL);
  },

  beforeDestroy() {
    removeClassBody();
  }
};
</script>

